// video-player.service.ts
import { Injectable } from '@angular/core';
import videojs from 'video.js';

@Injectable({
  providedIn: 'root'
})
export class VideoPlayerService {

  private activePlayer: ReturnType<typeof videojs> | null = null;

  setActivePlayer(player: ReturnType<typeof videojs> | null) {
    if (this.activePlayer && this.activePlayer !== player) {
      this.activePlayer.pause();
    }
    this.activePlayer = player;
  }

  clearActivePlayer(player: ReturnType<typeof videojs> | null = this.activePlayer) {
    if (this.activePlayer){
      this.activePlayer.pause();
    }
    if (this.activePlayer === player) {
      this.activePlayer = null;
    }
  }
}
